// extracted by mini-css-extract-plugin
export default {"remoteBlock":"Remote_remoteBlock__mjHKk","container":"Remote_container__ms8Qa","indent":"Remote_indent__T-GPP"};